import type { TFunction } from 'i18next';

type StepStatus = 'current' | 'complete' | 'future';

const getStepStatus = (currentStepIndex: number, i: number) =>
  currentStepIndex === i
    ? 'current'
    : currentStepIndex > i
      ? 'complete'
      : 'future';

export const getCapitalizedStepStatus = (
  t: TFunction,
  stepStatus: StepStatus
) => {
  switch (stepStatus) {
    case 'current':
      return t('Current');
    case 'complete':
      return t('Complete');
    case 'future':
      return t('Future');
    default:
      return '';
  }
};

export const getOffscreenStepStatus = (
  t: TFunction,
  stepStatus: StepStatus
) => {
  return stepStatus === 'complete'
    ? t('Completed step')
    : t('{{stepStatusCapitalized}} step', {
        stepStatusCapitalized: getCapitalizedStepStatus(t, stepStatus)
      });
};

export default getStepStatus;
